import React, { useState, useEffect, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

export default function RichTextEditor(props) {
  const [value, setValue] = useState(props.value);
  const editorRef = useRef(null);
  const preferredFont = localStorage.getItem('preferredFont') || 'Arial';

  return (
    <Editor
      onInit={(evt, editor) => {
        const preferredFont = localStorage.getItem('preferredFont');
        if (preferredFont) {
          editor.execCommand('FontName', false, preferredFont);
        }
      }}
      value={props.value}
      disabled={props.disabled}
      onEditorChange={props.onEditorChange || undefined}
      apiKey="pmug7se7u06hkbtsalfxvk9084ydpplf0vypapaq9hv1rlrm"
      init={{
        height: 500,
        width: '100%',
        menubar: props.menuBar || false,
        branding: false,
        browser_spellcheck: true,
        convert_urls: false,
        elementpath: false,
        plugins:
          'charmap emoticons image link lists media visualblocks table checklist casechange export formatpainter pageembed powerpaste advtable advcode editimage mergetags inlinecss autoresize pagebreak mergetags',
        toolbar:
          'mergetags | blocks fontfamily fontsize | forecolor backcolor emoticons bold italic underline | link image media table | align lineheight | checklist numlist bullist indent outdent | charmap | removeformat |',
        images_upload_url:
          URLROOT + 'api/v1/utilities/upload/file/cdn?accessToken=' + $('#GLOB_TOKEN').val(),
        toolbar_sticky: true,
        contextmenu: false,
        mergetags_list: props.mergeTags || [],
        forced_root_block: 'div',
        convert_urls: false,
        relative_urls: false,
        remove_script_host: false,
        font_family_formats: `
            Arial=arial,helvetica,sans-serif;
            Arial Black=arial black,avant garde;
            Comic Sans MS=comic sans ms,sans-serif;
            Courier New=courier new,courier;
            Georgia=georgia,palatino;
            Helvetica=helvetica;
            Impact=impact,chicago;
            Tahoma=tahoma,arial;
            Times New Roman=times new roman,times;
            Trebuchet MS=trebuchet ms,geneva;
            Verdana=verdana,geneva;
            `,
        setup: function (editor) {
          editor.on('ExecCommand', function (e) {
            if (e.command === 'FontName') {
              const font = editor.queryCommandValue('FontName');
              if (font) {
                localStorage.setItem('preferredFont', font);
              }
            }
          });
        },
      }}
    />
  );
}
